import Customer from "./Customer";
import BaseModel from "./BaseModel";
import Contact from "./Contact";
import Location from "./Location";
import CustomerEstimateItem from "./CustomerEstimateItem";
import User from "./User";
import Note from "./Note";

export default class CustomerEstimate extends BaseModel {

	static entity = 'customer_estimates';
	static route = 'customer-estimates';
	static plural = 'customer_estimates';
	static singular = 'customer_estimate';

	static fields () {
		return {
			id: this.attr(null),
			
			user_id: this.attr(null),
			user: this.belongsTo(User, 'user_id'),
			customer_id: this.attr(null),
			customer: this.belongsTo(Customer, 'customer_id'),
			contact_id: this.attr(null),
			contact: this.belongsTo(Contact, 'contact_id'),
			shipping_id: this.attr(null),
			shipping: this.belongsTo(Location, 'shipping_id'),
			// note_id: this.attr(null),
			// note: this.belongsTo(Note, 'note_id'),
			
			customer_name: this.attr(null),
			index: this.attr(null),
			number: this.attr(null),
			plan_number: this.attr(null),
			attention: this.attr(null),
			additional_emails: this.attr(null),
			tax_total: this.attr(null),
			sub_total: this.attr(null),
			total: this.attr(null),
			transport: this.attr(null),
			
			notes: this.attr(null),

			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),

			customer_estimate_items: this.hasMany(CustomerEstimateItem, 'customer_estimate_id', 'id')
		}
	}

	static configureApi() {
		let config = super.configureApi();
		config.actions.share = function(id) {
			return this.get('/'+CustomerEstimate.route+'/'+id+'/share', {}, {
				dataTransformer: () => {
					return [];
				}
			});
		};
		return config;
	}

	static apiConfig = this.configureApi();

}
